export default __webpack_public_path__ + "static/media/3.19eb32b0.png";